<template>
  <div class="plan-uploading">
    <h3 class="plan-uploading-title">
      Upload floor plans of your property
    </h3>
    <div class="plan-uploading-container">
      <div class="plan-uploading-container-files">
        <div class="plan-uploading-container-files-list">
          <template
            v-for="(plan, index) in uploadPlans"
            :key="plan.name + index">
            <div class="plan-uploading-container-files-list-item">
              <img
                class="plan-uploading-container-files-list-item-img"
                src="@/assets/img/plan-icon.svg"
                alt="plan-icon">
              <span class="plan-uploading-container-files-list-item-name">{{ plan.name }}</span>
              <button
                type="button"
                class="plan-uploading-container-files-list-item-delete"
                @click="openModal(index)">
                <img
                  src="@/assets/img/delete-icon.svg"
                  alt="delete-icon">
              </button>
            </div>
          </template>
        </div>
        <div class="plan-uploading-container-files-more">
          <label for="upload-plan-input">
            <img
              src="@/assets/img/order-steps/more.svg"
              alt="plus-icon">
            <input
              id="upload-plan-input"
              ref="input"
              multiple
              type="file"
              name="uploaded-plan"
              accept="image/*,application/pdf"
              title=""
              @change="upload">
            <span>Add files</span>
          </label>
          <p v-if="tryNextStep && uploadPlans.length === 0" class="plan-uploading-container-files-more-error">files are required</p>
        </div>
      </div>
      <div class="plan-uploading-container-additional">
        <div v-if="tariff === 3 || tariff === 6" class="plan-uploading-container-additional-brand">
          <div class="plan-uploading-container-additional-brand-logo" :class="tryNextStep && !logo ? 'error' : ''">
            <h5 class="plan-uploading-container-additional-title info">
              Add a logo
            </h5>
            <input
              accept="image/*,application/pdf"
              type="file"
              title=""
              class="plan-uploading-container-additional-brand-logo-input"
              :class="tryNextStep && !logo ? 'error-input' : ''"
              placeholder="Logo.png or Logo.svg"
              @change="(e) => {logo = e.target.files[0]}">
            <p
              class="plan-uploading-container-additional-brand-logo-name"
              :class="tryNextStep && !logo ? 'error-text' : logo ? '' : 'opacity'">
              {{ logo ? logo.name : 'Logo.png or Logo.svg' }}
            </p>
            <button
              v-if="logo"
              @click="() => {logo = null}"
              class="plan-uploading-container-additional-brand-delete">
              <img
                src="@/assets/img/delete-icon.svg"
                alt="delete-icon">
            </button>
          </div>
          <div class="plan-uploading-container-additional-brand-link">
            <h5 class="plan-uploading-container-additional-title">
              Link to your website
            </h5>
            <input
              v-model="link"
              class="plan-uploading-container-additional-brand-link-input"
              :class="tryNextStep && !link ? 'error-input' : ''"
              placeholder="Example: https://property.com">
            <button
              v-if="link"
              @click="() => {link = null}"
              class="plan-uploading-container-additional-brand-delete">
              <img
                src="@/assets/img/delete-icon.svg"
                alt="delete-icon">
            </button>
          </div>
          <img
            class="plan-uploading-container-additional-info"
            @click="() => {logoInfoVisible = true}"
            src="@/assets/img/order-steps/info.svg"
            alt="info">
          <div
            v-if="logoInfoVisible"
            class="plan-uploading-info">
            AI will include your logo and the website link of your company or property in the 360 virtual tour
            <img @click="() => {logoInfoVisible = false}" class="plan-uploading-info-close" src="@/assets/img/X_close.svg" alt="close-icon" />
          </div>
        </div>
        <div class="plan-uploading-container-additional-comment">
          <h5 class="plan-uploading-container-additional-title info">
            Comment on the order
          </h5>
          <textarea
            v-model="comment"
            class="plan-uploading-container-additional-comment-input"
            placeholder="What are your wishes for AI processing?" />
          <img
            class="plan-uploading-container-additional-info"
            @click="() => {commentInfoVisible = true}"
            src="@/assets/img/order-steps/info.svg"
            alt="info">
          <div v-if="commentInfoVisible" class="plan-uploading-info plan-uploading-info-right">
            You can share your thoughts on AI processing of your floor plan or comments about furniture size and placement
            <img @click="() => {commentInfoVisible = false}" class="plan-uploading-info-close" src="@/assets/img/X_close.svg" alt="close-icon" />
          </div>
        </div>
      </div>
    </div>
    <div class="order-modal-buttons">
      <button
        class="order-modal-button order-modal-button-second"
        @click="openPrevStep">
        Back
      </button>
      <button
        :class="{
          'btn-file-basic btn-form-uploading-basic' : tariff === 1,
          'btn-file-plus btn-form-uploading-plus' : tariff === 2,
          'btn-file-pro btn-form-uploading-pro' : tariff === 3,
          'btn-file-render btn-form-uploading-render' : tariff === 4,
          'btn-summary-max btn-form-uploading-max' : tariff === 6,
        }"
        class="order-modal-button"
        @click="next">
        {{ buttonText }}
      </button>
    </div>
    <div v-if="modalVisible" @click="() => {modalVisible = false}" class="plan-uploading-modal">
      <div @click="(e) => e.stopPropagation()" class="plan-uploading-modal-body">
        <img class="plan-uploading-modal-body-house" src="@/assets/img/order-steps/house-smile.svg" alt="house" />
        <h3 class="plan-uploading-modal-body-title">Are you sure?</h3>
        <p class="plan-uploading-modal-body-subtitle">You won’t be able revert this</p>
        <div class="plan-uploading-modal-body-buttons">
          <button @click="deleteFile()" class="plan-uploading-modal-body-buttons-item">Yes, delete it</button>
          <button @click="() => {modalVisible = false}" class="plan-uploading-modal-body-buttons-item">Cаncel</button>
        </div>
        <img @click="() => {modalVisible = false}" class="plan-uploading-modal-body-close" src="@/assets/img/X_close.svg" alt="close-icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlansUploading',
  props: {
    tariff: {
      default: 1,
      type: Number,
    },
    defaults: {
      default: () => {},
      type: Object,
    },
    save: {
      default: () => null,
      type: Function,
    },
    openNextStep: {
      default: () => null,
      type: Function,
    },
    openPrevStep: {
      default: () => null,
      type: Function,
    },
  },
  data: () => ({
    uploadPlans: [],
    logo: null,
    link: null,
    comment: null,
    modalVisible: false,
    deleteIndex: null,
    logoInfoVisible: false,
    commentInfoVisible: false,
    tryNextStep: false,
    buttonText: 'Next',
  }),
  mounted() {
    this.uploadPlans = this.defaults.plans;
    this.logo = this.defaults.logo;
    this.link = this.defaults.link;
    this.comment = this.defaults.comment;
  },
  methods: {
    upload(e) {
      this.uploadPlans = [...this.uploadPlans, ...e.target.files];
    },
    deleteFile() {
      this.uploadPlans.splice(this.deleteIndex, 1);
      this.deleteIndex = null;
      this.modalVisible = false;
    },
    openModal(index) {
      this.deleteIndex = index;
      this.modalVisible = true;
    },
    next() {
      this.tryNextStep = true;
      if ((this.tariff === 3 || this.tariff === 6) && (!this.logo || !this.link)) return;
      if (this.uploadPlans.length === 0) return;
      this.buttonText = 'Wait';
      this.save(this.uploadPlans, this.comment, this.logo, this.link)
        .then(() => this.openNextStep())
        .finally(() => this.buttonText = 'Next');
    },
  },
};
</script>
